/*!
 * headroom.js v0.12.0 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2020 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */


!function(t,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):(t=t||self).Headroom=n()}(this,function(){"use strict";function t(){return"undefined"!=typeof window}function d(t){return function(t){return t&&t.document&&function(t){return 9===t.nodeType}(t.document)}(t)?function(t){var n=t.document,o=n.body,s=n.documentElement;return{scrollHeight:function(){return Math.max(o.scrollHeight,s.scrollHeight,o.offsetHeight,s.offsetHeight,o.clientHeight,s.clientHeight)},height:function(){return t.innerHeight||s.clientHeight||o.clientHeight},scrollY:function(){return void 0!==t.pageYOffset?t.pageYOffset:(s||o.parentNode||o).scrollTop}}}(t):function(t){return{scrollHeight:function(){return Math.max(t.scrollHeight,t.offsetHeight,t.clientHeight)},height:function(){return Math.max(t.offsetHeight,t.clientHeight)},scrollY:function(){return t.scrollTop}}}(t)}function n(t,s,e){var n,o=function(){var n=!1;try{var t={get passive(){n=!0}};window.addEventListener("test",t,t),window.removeEventListener("test",t,t)}catch(t){n=!1}return n}(),i=!1,r=d(t),l=r.scrollY(),a={};function c(){var t=Math.round(r.scrollY()),n=r.height(),o=r.scrollHeight();a.scrollY=t,a.lastScrollY=l,a.direction=l<t?"down":"up",a.distance=Math.abs(t-l),a.isOutOfBounds=t<0||o<t+n,a.top=t<=s.offset[a.direction],a.bottom=o<=t+n,a.toleranceExceeded=a.distance>s.tolerance[a.direction],e(a),l=t,i=!1}function h(){i||(i=!0,n=requestAnimationFrame(c))}var u=!!o&&{passive:!0,capture:!1};return t.addEventListener("scroll",h,u),c(),{destroy:function(){cancelAnimationFrame(n),t.removeEventListener("scroll",h,u)}}}function o(t){return t===Object(t)?t:{down:t,up:t}}function s(t,n){n=n||{},Object.assign(this,s.options,n),this.classes=Object.assign({},s.options.classes,n.classes),this.elem=t,this.tolerance=o(this.tolerance),this.offset=o(this.offset),this.initialised=!1,this.frozen=!1}return s.prototype={constructor:s,init:function(){return s.cutsTheMustard&&!this.initialised&&(this.addClass("initial"),this.initialised=!0,setTimeout(function(t){t.scrollTracker=n(t.scroller,{offset:t.offset,tolerance:t.tolerance},t.update.bind(t))},100,this)),this},destroy:function(){this.initialised=!1,Object.keys(this.classes).forEach(this.removeClass,this),this.scrollTracker.destroy()},unpin:function(){!this.hasClass("pinned")&&this.hasClass("unpinned")||(this.addClass("unpinned"),this.removeClass("pinned"),this.onUnpin&&this.onUnpin.call(this))},pin:function(){this.hasClass("unpinned")&&(this.addClass("pinned"),this.removeClass("unpinned"),this.onPin&&this.onPin.call(this))},freeze:function(){this.frozen=!0,this.addClass("frozen")},unfreeze:function(){this.frozen=!1,this.removeClass("frozen")},top:function(){this.hasClass("top")||(this.addClass("top"),this.removeClass("notTop"),this.onTop&&this.onTop.call(this))},notTop:function(){this.hasClass("notTop")||(this.addClass("notTop"),this.removeClass("top"),this.onNotTop&&this.onNotTop.call(this))},bottom:function(){this.hasClass("bottom")||(this.addClass("bottom"),this.removeClass("notBottom"),this.onBottom&&this.onBottom.call(this))},notBottom:function(){this.hasClass("notBottom")||(this.addClass("notBottom"),this.removeClass("bottom"),this.onNotBottom&&this.onNotBottom.call(this))},shouldUnpin:function(t){return"down"===t.direction&&!t.top&&t.toleranceExceeded},shouldPin:function(t){return"up"===t.direction&&t.toleranceExceeded||t.top},addClass:function(t){this.elem.classList.add.apply(this.elem.classList,this.classes[t].split(" "))},removeClass:function(t){this.elem.classList.remove.apply(this.elem.classList,this.classes[t].split(" "))},hasClass:function(t){return this.classes[t].split(" ").every(function(t){return this.classList.contains(t)},this.elem)},update:function(t){t.isOutOfBounds||!0!==this.frozen&&(t.top?this.top():this.notTop(),t.bottom?this.bottom():this.notBottom(),this.shouldUnpin(t)?this.unpin():this.shouldPin(t)&&this.pin())}},s.options={tolerance:{up:0,down:0},offset:0,scroller:t()?window:null,classes:{frozen:"headroom--frozen",pinned:"headroom--pinned",unpinned:"headroom--unpinned",top:"headroom--top",notTop:"headroom--not-top",bottom:"headroom--bottom",notBottom:"headroom--not-bottom",initial:"headroom"}},s.cutsTheMustard=!!(t()&&function(){}.bind&&"classList"in document.documentElement&&Object.assign&&Object.keys&&requestAnimationFrame),s});


jQuery(document).ready(function($) {
	jQuery(".next-div").click(function(event){
		event.preventDefault();
		var asd=jQuery(".site-content");
		
		if(jQuery(window).width() < 767.1){
		
			jQuery('html,body').stop().animate({scrollTop:asd.offset().top - 60},600);
	
		}else{
			jQuery('html,body').stop().animate({scrollTop:asd.offset().top - 72},600);
		}
	});
	
	
	jQuery("#boost-pfs-filter-tree").click(function(event){
		// but not if the element target clicked is .boost-pfs-filter-button-arrow 
		if(!jQuery(event.target).closest(".boost-pfs-filter-button-arrow").length > 0){
			event.stopPropagation();
			jQuery(".boost-pfs-filter-tree-mobile-button button")[0].click();
		}
		
	});

	
	jQuery(".boost-pfs-filter-tree-content").click(function(event){
		event.stopPropagation();
	});
	
	

	jQuery("#notify-modal").append("<div class='login-modal-show'></div>");
	
	
	jQuery("body").on("click",".notify-modal-show",function(event){
		event.stopPropagation();
		jQuery("#login-modal").fadeOut(600);
		jQuery("body").removeClass("modal-open");
	});

	
	
	
	jQuery("#login-modal").append("<div class='login-modal-show'></div>");
	
	
	jQuery("body").on("click",".login-modal-show",function(event){
		event.stopPropagation();
		jQuery("#login-modal").fadeOut(600);
		jQuery("body").removeClass("modal-open");
	});

	
	jQuery("#cart-panel .open-login-modal").click(function(event){
		
		jQuery("body").removeClass("open-canvas-panel");
		jQuery("#cart-panel").removeClass("open");
	});
	
	jQuery("#shopify-section-cart-template .rt-unero-cart-form__cart-item").each(function(event){
		var this_c=jQuery(this);
		var ids=jQuery(this).attr("data-id");
		if(ids == "39509801926836"){
			this_c.addClass("not-add-to-cart");
			this_c.find(".product-quantity").find("input").val("1");
		}
	});
	
	
	jQuery("#shopify-section-cart-template .rt-unero-cart-form__cart-item").each(function(event){
		var this_c=jQuery(this);
		var ids=jQuery(this).attr("data-id");
		if(ids == "39509801926836"){
			this_c.addClass("not-add-to-cart");
			this_c.find(".product-quantity").find("input").val("1");
		}
	});
	
	
	
	
	
	
	///filter
	
	
	
	///filter  end
	jQuery(window).scroll(function() {
		var sh = jQuery(window).scrollTop();
		if (sh > 38) {
			//jQuery(".add-back-link").addClass("head-small");

		} else if (sh <= 1) {
			//jQuery(".add-back-link").removeClass("head-small");
		}
		
	});
	
	



	// open Filter toggle
	jQuery("body").on("click",".boost-mobile-filter-toggle",function(event){
		jQuery(".boost-mobile-filter-toggle").toggleClass("is-active");
		jQuery(".mobile-filters").toggleClass("is-active");
	});
	
	
	
	


// grab an element
var myElement = document.querySelector("header");

var options = {
    // vertical offset in px before element is first unpinned
    offset : 0,
    // or you can specify offset individually for up/down scroll
    offset: {
        up: 100,
        down: 50
    },
    // scroll tolerance in px before state changes
    tolerance : 0,
    // or you can specify tolerance individually for up/down scroll
    tolerance : {
        up : 5,
        down : 0
    },
    // css classes to apply
    classes : {
        // when element is initialised
        initial : "headroom",
        // when scrolling up
        pinned : "headroom--pinned",
        // when scrolling down
        unpinned : "headroom--unpinned",
        // when above offset
        top : "headroom--top",
        // when below offset
        notTop : "headroom--not-top",
        // when at bottom of scroll area
        bottom : "headroom--bottom",
        // when not at bottom of scroll area
        notBottom : "headroom--not-bottom",
        // when frozen method has been called
        frozen: "headroom--frozen",
        // multiple classes are also supported with a space-separated list
        pinned: "headroom--pinned foo bar"
    },
    // element to listen to scroll events on, defaults to `window`
    //scroller : someElement,
    // callback when pinned, `this` is headroom object
    onPin : function() {
		jQuery(".boost-collection-header").addClass("push-down");
		jQuery(".boost-pfs-filter-option.boost-pfs-filter-option-box").removeClass("pull-up");
	},
    // callback when unpinned, `this` is headroom object
    onUnpin : function() {
		jQuery(".boost-collection-header").removeClass("push-down");
		jQuery(".boost-pfs-filter-option.boost-pfs-filter-option-box").addClass("pull-up");
	},
    // callback when above offset, `this` is headroom object
    onTop : function() {},
    // callback when below offset, `this` is headroom object
    onNotTop : function() {},
    // callback when at bottom of page, `this` is headroom object
    onBottom : function() {},
    // callback when moving away from bottom of page, `this` is headroom object
    onNotBottom : function() {}
};


// construct an instance of Headroom, passing the element
var headroom  = new Headroom(myElement, options);
// initialise
//headroom.init();


});






/* BIS FORM */

const BISform = document.querySelector('#BIS-form');
let BISname = '';
let BISvariant = ''; // Not Product ID

BISform.addEventListener('submit', (e) => {
	e.preventDefault();

	const BISemail = BISform.querySelector('#BIS-email-input').value;

	const payload = {
		"data": {
			"type": "back-in-stock-subscription",
			"attributes": {
				"profile": {
					"data": {
						"type": "profile",
						"attributes": {
							"email": BISemail,
						}
					}
				},
				"channels": ["EMAIL"],
			},
			"relationships": {
				"variant": {
					"data": {
						"type": "catalog-variant",
						"id": `$shopify:::$default:::${BISvariant}`
					}
				}
			}
		}
	};
	
	var requestOptions = {
		method: 'POST',
		headers: {
			"Content-Type": "application/json",
			"revision": "2024-06-15"
		},
		body: JSON.stringify(payload),
	};
	
	fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=J5FYTE", requestOptions)
		.then(response => {
			if (!response.ok) {
				return response.json().then(errorData => {
					throw new Error(errorData.errors[0].detail);
				});
			}
			return response;
		})
		.then(result => {
			//console.log(result);
	
			// Update the form UI on success
			$('#BIS-form input[type="submit"]').val('We will be in touch');
			$('#BIS-form input[type="submit"]').attr('disabled', true);
			$('#notify-modal').delay(3000).fadeOut(1000);
			$('body').removeClass('modal-open');
		})
		.catch(error => {
			console.log('error', error);
	
			// Update the form UI on error
			$('#BIS-form input[type="submit"]').val(error.message);
			$('#BIS-form input[type="submit"]').attr('disabled', true);
			// delay and then reset the button text back to orignal
			$('#BIS-form input[type="submit"]').delay(3000).queue(function(next){
				$(this).val('Notify when available');
				$(this).attr('disabled', false);
				next();
			});
		});

});


$("body").on("click","button[data-soldout]",function(e){
    e.preventDefault();
    $('#notify-modal').addClass('open');
    $('#notify-modal').fadeIn();
    $('body').addClass('modal-open');

	$('#BIS-form input[type="submit"]').val('Notify when available');
	$('#BIS-form input[type="submit"]').attr('disabled', false);

	BISvariant = $(this).data('vid');
	console.log(BISvariant);

	BISname = $(this).data('name');
	$('#notify-modal .modal-title span').text(BISname);

});